/**
 * Custom Tiptap Node for YouTube embed compatible with email clients (Gmail, Outlook).
 * Renders as <a href="..."><img src="thumbnail"/></a> — no iframe, displayed in editor and email.
 */
import { Node, mergeAttributes } from '@tiptap/core';

export function extractYouTubeId(url) {
  if (!url) return '';
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return '';
}

export const YouTubeEmbed = Node.create({
  name: 'youtubeEmbed',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      videoId: { default: '' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'a[data-type="youtube"]',
        getAttrs: (el) => ({ videoId: el.getAttribute('data-video-id') || '' }),
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const id = node.attrs.videoId;
    const thumb = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        href: `https://www.youtube.com/watch?v=${id}`,
        target: '_blank',
        rel: 'noopener noreferrer',
        'data-type': 'youtube',
        'data-video-id': id,
        style:
          'display:block;text-align:center;text-decoration:none;margin:16px 0;position:relative;',
      }),
      [
        'img',
        {
          src: thumb,
          alt: 'Vidéo YouTube',
          style:
            'max-width:100%;width:480px;height:auto;display:block;margin:0 auto;border-radius:6px;',
        },
      ],
    ];
  },

  addCommands() {
    return {
      insertYouTube:
        (url) =>
        ({ commands }) => {
          const id = extractYouTubeId(url);
          if (!id) return false;
          return commands.insertContent({
            type: this.name,
            attrs: { videoId: id },
          });
        },
    };
  },
});
